import api from './client'

export interface SyncDevice {
  id: string
  name: string
  username: string
  createdAt: string
  createdByName: string | null
  revokedAt: string | null
  revokedByName: string | null
  lastSyncAt: string | null
  lastSyncIp: string | null
  lastSyncUserAgent: string | null
}

/** Returned once, when access is added. The password is never available again. */
export interface NewSyncDevice {
  device: SyncDevice
  username: string
  password: string
}

/** The address phones subscribe to — the same for every phone, nothing secret in it. */
export const FEED_PATH = '/api/v1/appointments-sync/feed.ics'

const base = (cid: string) => `/companies/${cid}/appointments-sync/devices`

export const appointmentsSyncApi = {
  list: (cid: string) => api.get<SyncDevice[]>(base(cid)).then(r => r.data),
  create: (cid: string, name: string) => api.post<NewSyncDevice>(base(cid), { name }).then(r => r.data),
  revoke: (cid: string, id: string) => api.post<SyncDevice>(`${base(cid)}/${id}/revoke`).then(r => r.data),
}
